import Plot from 'react-plotly.js';

//
// Plot layout. Uses Plotly.
// npm install react-plotly.js plotly.js
// https://plotly.com/javascript/react/
//
const k_colors = [
    "black",
    "red",
    "blue",
    "green",
    "orange"
];

const PlotWidget = (props) => {
    let specification;

    function plot(data) {
        let curves = [];
        let curve;
        for (let i = 0; i < data.curves.length; ++i) {
            curve = data.curves[i];
            curves.push({
                name: curve.name,
                x: curve.x,
                y: curve.y,
                mode: "lines",
                type: "scatter",
                line: {
                    color: k_colors[i]
                }
            });
        }

        let layout = {
            xaxis: { title: data.xlegend },
            yaxis: { title: data.ylegend },
            title: data.title
        };

        let spec = {
            curves: curves,
            layout: layout
        };

        specification = spec;
    }

    plot(props.curves);

    return (
        <div>
            {specification &&
                <Plot
                    data={specification.curves}
                    layout={specification.layout}
                />
            }
        </div>
    );
}

export default PlotWidget;